import Polyglot from 'node-polyglot';
import { Locale } from '../../types/common';

import { VICTIM_VALIDATION_MSG } from '../messages/victim';
import { PLAQUE_VALIDATION_MSG } from '../messages/plaque';

function loadPolyglot(
  locale: Locale,
  validationObj: { ua: object, en: object },
): Polyglot {
  const translations = locale === 'en'
    ? validationObj.en
    : validationObj.ua;
  const polyglot = new Polyglot({
    interpolation: { prefix: '{{', suffix: '}}' },
  });

  polyglot.extend(translations);

  return polyglot;
}

export const loadVictimPolyglot = (locale: Locale) => (
  loadPolyglot(locale, VICTIM_VALIDATION_MSG)
);

export const loadPlaquePolyglot = (locale: Locale) => (
  loadPolyglot(locale, PLAQUE_VALIDATION_MSG)
);
